
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1NzGW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ServiceDeskChatSettingsPage", () => $9476b8bc4ad8a892$export$5d40729c23a05c35);
$parcel$export(module.exports, "default", () => $9476b8bc4ad8a892$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $0cdA8 = parcelRequire("0cdA8");

var $iVSJI = parcelRequire("iVSJI");

var $dWvpo = parcelRequire("dWvpo");

var $kKzsy = parcelRequire("kKzsy");

var $2wMrb = parcelRequire("2wMrb");

var $kCywN = parcelRequire("kCywN");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $1DZLA = parcelRequire("1DZLA");


var $eZLHv = parcelRequire("eZLHv");
const $9476b8bc4ad8a892$export$5d40729c23a05c35 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: data } = (0, $eZLHv.default)();
    const projectContext = data;
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const { projectKey: projectKey } = match.params;
    const [{ data: gspData }, { resolveTask: resolveTask }] = (0, $dWvpo.useGettingStartedPanelState)();
    (0, $eUqFw.useEffect)(()=>{
        if (gspData) resolveTask('servicedesk-chat-requests-setup').catch();
    }, [
        gspData,
        resolveTask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $87152ecb5ef8ce49$export$5721fd5d6ba543ca),
        packageName: "jiraSpaAppsProjectSettingsServiceDeskChatSettings",
        teamName: "itops-mithril",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wMrb.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DZLA.default), {
        tenantContext: tenantContext,
        projectContext: projectContext
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};
var $9476b8bc4ad8a892$export$2e2bcd8739ae039 = $9476b8bc4ad8a892$export$5d40729c23a05c35;

});
parcelRegister("dWvpo", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $f367f2772b7579d7$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $f367f2772b7579d7$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $f367f2772b7579d7$export$bb089b373d239cdd);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $bFzGY = parcelRequire("bFzGY");

var $h4Fhh = parcelRequire("h4Fhh");

var $SEaoU = parcelRequire("SEaoU");

var $IsF0v = parcelRequire("IsF0v");


var $lhDSB = parcelRequire("lhDSB");

var $gEZA0 = parcelRequire("gEZA0");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $8u09c = parcelRequire("8u09c");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $dIgUk = parcelRequire("dIgUk");
const $f367f2772b7579d7$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $f367f2772b7579d7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $f367f2772b7579d7$var$initialState,
    actions: (0, $dIgUk.actions)
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreState = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $8u09c.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreActions = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $f367f2772b7579d7$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $lhDSB.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $ef7033652bab160b$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $f367f2772b7579d7$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $f367f2772b7579d7$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(containerContext.project) ? (0, $6vrw7.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $f367f2772b7579d7$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $lB25E.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $lB25E.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $f367f2772b7579d7$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $f367f2772b7579d7$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $6vrw7.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $f367f2772b7579d7$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const isProjectTourSeen = $f367f2772b7579d7$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $f367f2772b7579d7$export$97247be508d7d058();
    const enableUserCentricMode = $f367f2772b7579d7$export$678a38a9dc2d3a0();
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $f367f2772b7579d7$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $f367f2772b7579d7$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [state, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreState();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $f367f2772b7579d7$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $f367f2772b7579d7$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $eUqFw.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
const $ef7033652bab160b$export$17227441e89ee693 = 'INITIAL';
const $ef7033652bab160b$export$23324e66dcb20cea = 'NOTSEEN';
const $ef7033652bab160b$export$e47bc222770d5cfd = 'SEEN';
const $ef7033652bab160b$export$103bedf43ba882db = 'ERROR';
const $ef7033652bab160b$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $ef7033652bab160b$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("lhDSB", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $3c47e23fdd4320f6$export$4aecabf781c5d857);

var $eUqFw = parcelRequire("eUqFw");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $d2tO7 = parcelRequire("d2tO7");
const $3c47e23fdd4320f6$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $3c47e23fdd4320f6$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $3c47e23fdd4320f6$export$d4c72bab9d6cc13a,
    actions: (0, $d2tO7.actions)
});
const $3c47e23fdd4320f6$var$useStore = (0, $WBLbN.createHook)($3c47e23fdd4320f6$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $3c47e23fdd4320f6$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $eUqFw.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $3c47e23fdd4320f6$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $3c47e23fdd4320f6$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, actions] = $3c47e23fdd4320f6$var$useStore();
    const memoizedActions = $3c47e23fdd4320f6$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $3c47e23fdd4320f6$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("d2tO7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5324b94d76febd17$export$e324594224ef24da);

var $eU696 = parcelRequire("eU696");

var $dv6lu = parcelRequire("dv6lu");
const $5324b94d76febd17$export$e324594224ef24da = {
    getTourState: $eU696.getTourState,
    setTourState: $dv6lu.setTourState
};

});
parcelRegister("eU696", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $4c66438699410e17$export$a758fd93ae41dde5);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $6vrw7 = parcelRequire("6vrw7");

const $4c66438699410e17$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $4c66438699410e17$var$fetchTourState = async (baseUrl)=>{
    const url = $4c66438699410e17$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $fVqUX.default));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7byHA.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $4c66438699410e17$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $4c66438699410e17$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $6vrw7.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $JRB5w.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("dv6lu", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $106ad4ed6da8c60b$export$35f9649c739aaca3);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

const $106ad4ed6da8c60b$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $106ad4ed6da8c60b$var$putTourState = async (baseUrl, tourState)=>{
    const url = $106ad4ed6da8c60b$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $fVqUX.default),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7byHA.default)(response.status, text);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $106ad4ed6da8c60b$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $106ad4ed6da8c60b$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $WBLbN.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $WBLbN.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("8u09c", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $07b01345748f10fb$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $07b01345748f10fb$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $07b01345748f10fb$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $07b01345748f10fb$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $07b01345748f10fb$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $07b01345748f10fb$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $07b01345748f10fb$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $07b01345748f10fb$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $07b01345748f10fb$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $07b01345748f10fb$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $07b01345748f10fb$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $07b01345748f10fb$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $07b01345748f10fb$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $07b01345748f10fb$export$4f537e3bd8843f30);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $07b01345748f10fb$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $07b01345748f10fb$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $07b01345748f10fb$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $07b01345748f10fb$export$e6bec6a1026bf0b4);
var $07b01345748f10fb$export$2f27df41e8b7edbb;
(function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
})($07b01345748f10fb$export$2f27df41e8b7edbb || ($07b01345748f10fb$export$2f27df41e8b7edbb = {}));
var $07b01345748f10fb$export$285eeaa5f468cfb6;
(function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
})($07b01345748f10fb$export$285eeaa5f468cfb6 || ($07b01345748f10fb$export$285eeaa5f468cfb6 = {}));
var $07b01345748f10fb$export$264ad599d7cef668;
(function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
})($07b01345748f10fb$export$264ad599d7cef668 || ($07b01345748f10fb$export$264ad599d7cef668 = {}));
var $07b01345748f10fb$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
})($07b01345748f10fb$export$7dc6752a22ab011a || ($07b01345748f10fb$export$7dc6752a22ab011a = {}));
var $07b01345748f10fb$export$f4906a03a7a2d0af;
(function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
})($07b01345748f10fb$export$f4906a03a7a2d0af || ($07b01345748f10fb$export$f4906a03a7a2d0af = {}));
var $07b01345748f10fb$export$4f1a05ccc35315c6;
(function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
})($07b01345748f10fb$export$4f1a05ccc35315c6 || ($07b01345748f10fb$export$4f1a05ccc35315c6 = {}));
var $07b01345748f10fb$export$aa90cbc80c330872;
(function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
})($07b01345748f10fb$export$aa90cbc80c330872 || ($07b01345748f10fb$export$aa90cbc80c330872 = {}));
var $07b01345748f10fb$export$38aab4015a34ead;
(function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
})($07b01345748f10fb$export$38aab4015a34ead || ($07b01345748f10fb$export$38aab4015a34ead = {}));
var $07b01345748f10fb$export$10cc267f702fbadd;
(function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
})($07b01345748f10fb$export$10cc267f702fbadd || ($07b01345748f10fb$export$10cc267f702fbadd = {}));
const $07b01345748f10fb$export$9846214c9c3411dc = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-logo-added-to-portal",
    "servicedesk-email-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added",
    "servicedesk-basics-documentation-accessed"
];
const $07b01345748f10fb$export$fe6666d729b0d637 = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-email-requests-setup",
    "servicedesk-chat-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added"
];
const $07b01345748f10fb$export$ed4dcaac45c6a484 = [
    "servicedesk-team-efficiency-automate-your-work",
    "servicedesk-team-efficiency-setup-knowledge-base"
];
const $07b01345748f10fb$export$3de0dd66b0de4cdc = [
    "servicedesk-change-management-pipeline-connected",
    "servicedesk-change-management-change-approvers-added",
    "servicedesk-change-management-documentation-accessed"
];
const $07b01345748f10fb$export$2852680309cf5a68 = [
    "opsgenie-user-profile-notifications-setup",
    "opsgenie-response-team-setup",
    "opsgenie-owner-team-assigned-to-service",
    "opsgenie-incident-management-documentation-accessed"
];
const $07b01345748f10fb$export$4f537e3bd8843f30 = [
    "opsgenie-enable-ops-for-team",
    "opsgenie-review-oncall-setup",
    "opsgenie-add-integration",
    "opsgenie-setup-ops-notifications",
    "opsgenie-review-alerts"
];
var $07b01345748f10fb$export$72401d057976d548;
(function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
})($07b01345748f10fb$export$72401d057976d548 || ($07b01345748f10fb$export$72401d057976d548 = {}));
var $07b01345748f10fb$export$7d7a98f44861e6f7;
(function(ContainerType) {
    ContainerType["Project"] = "project";
})($07b01345748f10fb$export$7d7a98f44861e6f7 || ($07b01345748f10fb$export$7d7a98f44861e6f7 = {}));
var $07b01345748f10fb$export$d7341fa10d264a87;
(function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
})($07b01345748f10fb$export$d7341fa10d264a87 || ($07b01345748f10fb$export$d7341fa10d264a87 = {}));
var $07b01345748f10fb$export$e6bec6a1026bf0b4;
(function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
})($07b01345748f10fb$export$e6bec6a1026bf0b4 || ($07b01345748f10fb$export$e6bec6a1026bf0b4 = {}));

});

parcelRegister("dIgUk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $74d379822532afde$export$e324594224ef24da);

var $bqfo7 = parcelRequire("bqfo7");

var $lKOEf = parcelRequire("lKOEf");

var $zvnJx = parcelRequire("zvnJx");

var $82jJZ = parcelRequire("82jJZ");

var $kYwcF = parcelRequire("kYwcF");

var $3ZIER = parcelRequire("3ZIER");

var $aXUph = parcelRequire("aXUph");

var $1mctb = parcelRequire("1mctb");

var $ghO9h = parcelRequire("ghO9h");
const $74d379822532afde$export$e324594224ef24da = {
    initializeState: $lKOEf.initializeState,
    fetchState: $bqfo7.fetchState,
    savePanelState: $3ZIER.savePanelState,
    reopenGettingStartedPanel: $82jJZ.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $zvnJx.markReopenSpotlightAsSeen,
    resolveTask: $kYwcF.resolveTask,
    saveProperty: $aXUph.saveProperty,
    stopRecordingPerformanceExperiences: $ghO9h.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $1mctb.setOpsAdminTaskVisibility
};

});
parcelRegister("bqfo7", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $966d678a0c07fdc2$export$f3df9013f2b58bce);

var $1c8hB = parcelRequire("1c8hB");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $feGjZ = parcelRequire("feGjZ");

var $4ZYEI = parcelRequire("4ZYEI");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");


var $1dL7Z = parcelRequire("1dL7Z");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $lKOEf = parcelRequire("lKOEf");
const $966d678a0c07fdc2$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $966d678a0c07fdc2$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const isNpleForItsmEnabled = (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const hasProject = (isNpleForItsmEnabled || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $lKOEf.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $966d678a0c07fdc2$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(response)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(completedTasks)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(properties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(userProperties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(sectionStateString)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $966d678a0c07fdc2$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $2OdyW.default)((0, $lKOEf.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $966d678a0c07fdc2$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $1dL7Z.isExpectedError)(error)) return;
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $966d678a0c07fdc2$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
const $ae3aa738acb13786$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$47712c7937145142 = 320;
const $ae3aa738acb13786$export$1cad4f611a1c0229 = 220;
const $ae3aa738acb13786$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$bc8b984358922f81 = 'team';
const $ae3aa738acb13786$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $ae3aa738acb13786$export$cbbd90bf5df877bd = 'cloudid';
const $ae3aa738acb13786$export$a74074a8f4372ab0 = 'referrer';

parcelRegister("1dL7Z", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $1d31dcdfdfe25380$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $1d31dcdfdfe25380$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $1d31dcdfdfe25380$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $1d31dcdfdfe25380$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $1d31dcdfdfe25380$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $1d31dcdfdfe25380$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $2oOo5 = parcelRequire("2oOo5");

var $JRB5w = parcelRequire("JRB5w");
const $1d31dcdfdfe25380$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $1d31dcdfdfe25380$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $1d31dcdfdfe25380$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $1d31dcdfdfe25380$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $1d31dcdfdfe25380$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$f8f0d4e52d7e9716 = (pathname)=>$1d31dcdfdfe25380$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $1d31dcdfdfe25380$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $1d31dcdfdfe25380$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $1d31dcdfdfe25380$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $1d31dcdfdfe25380$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $1d31dcdfdfe25380$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $1d31dcdfdfe25380$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $1d31dcdfdfe25380$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $1d31dcdfdfe25380$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $1d31dcdfdfe25380$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $1d31dcdfdfe25380$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $1d31dcdfdfe25380$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $1d31dcdfdfe25380$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $1d31dcdfdfe25380$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $1d31dcdfdfe25380$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $1d31dcdfdfe25380$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $1d31dcdfdfe25380$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $1d31dcdfdfe25380$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $1d31dcdfdfe25380$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $1d31dcdfdfe25380$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $1d31dcdfdfe25380$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $1d31dcdfdfe25380$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $1d31dcdfdfe25380$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $1d31dcdfdfe25380$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $1d31dcdfdfe25380$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $1d31dcdfdfe25380$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $1d31dcdfdfe25380$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$a6e1eca03e2de987 = (pathname)=>$1d31dcdfdfe25380$export$dbf902576403f80e(pathname) || $1d31dcdfdfe25380$export$458d0b4237ae1dad(pathname) || $1d31dcdfdfe25380$export$3b5fbfd2bca32dde(pathname) || $1d31dcdfdfe25380$export$aeffbab88b3257bb(pathname) || $1d31dcdfdfe25380$export$7e3236de8c2c8fcb(pathname) || $1d31dcdfdfe25380$export$908f99db4c2098a0(pathname) || $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66(pathname) || $1d31dcdfdfe25380$export$f4e3d864ce1a2f74(pathname) || $1d31dcdfdfe25380$export$21361d1ad00e769e(pathname) || $1d31dcdfdfe25380$export$6208845cb364d4de(pathname) || $1d31dcdfdfe25380$export$16978d524c086b4(pathname) || $1d31dcdfdfe25380$export$b6d6b41b75346458(pathname) || $1d31dcdfdfe25380$export$5b2153f9a7427657(pathname) || $1d31dcdfdfe25380$export$c5434c69e9b50e81(pathname) || $1d31dcdfdfe25380$export$3a7002667b72e8d7(pathname) || $1d31dcdfdfe25380$export$542a1f79f5837827(pathname) || $1d31dcdfdfe25380$export$b748c9dbd5996d34(pathname) || $1d31dcdfdfe25380$export$455a6199a321423(pathname) || $1d31dcdfdfe25380$export$fa426b2da28e4ae2(pathname) || $1d31dcdfdfe25380$export$fc0fba46b7584812(pathname) || $1d31dcdfdfe25380$export$882325faa1a194c6(pathname) || $1d31dcdfdfe25380$export$8bb0073f55baf38b(pathname) || $1d31dcdfdfe25380$export$1b69f3aa169f179(pathname) || $1d31dcdfdfe25380$export$1c47b1cb87da237(pathname) || $1d31dcdfdfe25380$export$ee56a66aa8efb6da(pathname) || $1d31dcdfdfe25380$export$6256b4d737fa56f2(pathname) || $1d31dcdfdfe25380$export$3f77d24f8de610a0(pathname);
const $1d31dcdfdfe25380$var$screenNameMap = {
    queues: $1d31dcdfdfe25380$export$d7638addf23014e7,
    issues: $1d31dcdfdfe25380$export$1b685dac913c7026,
    customers: $1d31dcdfdfe25380$export$6292763547421a38,
    reports: $1d31dcdfdfe25380$export$a05100bbf8bc68c3,
    knowledge: $1d31dcdfdfe25380$export$e75cc3ec1f686973,
    services: $1d31dcdfdfe25380$export$66d002c194bc72aa,
    onCall: $1d31dcdfdfe25380$export$430089990bd4af09,
    incidents: $1d31dcdfdfe25380$export$a655a298d384c316,
    problems: $1d31dcdfdfe25380$export$1c5f444b718144b7,
    changes: $1d31dcdfdfe25380$export$42dd8a49c7fa462c,
    serviceRequests: $1d31dcdfdfe25380$export$5c77a7ea15a04e63,
    classicSettingsDetails: $1d31dcdfdfe25380$export$dbf902576403f80e,
    classicSettingsPeople: $1d31dcdfdfe25380$export$458d0b4237ae1dad,
    classicSettingsSummary: $1d31dcdfdfe25380$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $1d31dcdfdfe25380$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $1d31dcdfdfe25380$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $1d31dcdfdfe25380$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $1d31dcdfdfe25380$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $1d31dcdfdfe25380$export$21361d1ad00e769e,
    classicSettingsEmail: $1d31dcdfdfe25380$export$6208845cb364d4de,
    classicSettingsEmailAlias: $1d31dcdfdfe25380$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $1d31dcdfdfe25380$export$b6d6b41b75346458,
    classicSettingsWidget: $1d31dcdfdfe25380$export$5b2153f9a7427657,
    classicSettingsFeedback: $1d31dcdfdfe25380$export$c5434c69e9b50e81,
    classicSettingsConfluence: $1d31dcdfdfe25380$export$3a7002667b72e8d7,
    classicSettingsSla: $1d31dcdfdfe25380$export$542a1f79f5837827,
    classicSettingsAutomation: $1d31dcdfdfe25380$export$b748c9dbd5996d34,
    classicSettingsApps: $1d31dcdfdfe25380$export$455a6199a321423,
    classicSettingsWorkflows: $1d31dcdfdfe25380$export$fa426b2da28e4ae2,
    classicSettingsScreens: $1d31dcdfdfe25380$export$fc0fba46b7584812,
    classicSettingsFields: $1d31dcdfdfe25380$export$882325faa1a194c6,
    classicSettingsVersions: $1d31dcdfdfe25380$export$8bb0073f55baf38b,
    classicSettingsComponents: $1d31dcdfdfe25380$export$1b69f3aa169f179,
    classicSettingsPermissions: $1d31dcdfdfe25380$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $1d31dcdfdfe25380$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $1d31dcdfdfe25380$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $1d31dcdfdfe25380$export$3f77d24f8de610a0
};
const $1d31dcdfdfe25380$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($2oOo5)))($1d31dcdfdfe25380$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $1d31dcdfdfe25380$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $JRB5w.isClientFetchError)(error);
const $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Summary',
        'servicedesk-reports-summary',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $1d31dcdfdfe25380$export$83501d9ba065ef89 = (pathname)=>$1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$5d52a100c70d4375 = (currentRouteName)=>$1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("2oOo5", function(module, exports) {

var $1FGIk = parcelRequire("1FGIk");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $1bf4e8901877f248$var$findKey(object, predicate) {
    return $1FGIk(object, $7qARj(predicate, 3), $piimr);
}
module.exports = $1bf4e8901877f248$var$findKey;

});
parcelRegister("1FGIk", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $137ac0dffc9def22$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $137ac0dffc9def22$var$baseFindKey;

});



parcelRegister("isHzQ", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $c920f201dd81d401$export$b05151222ac96edd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
var $4eEU1 = parcelRequire("4eEU1");
async function $c920f201dd81d401$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $4eEU1.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("4eEU1", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $5d00ee66e441ccba$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "SdVisibilityKeys", () => $5d00ee66e441ccba$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $5d00ee66e441ccba$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $5d00ee66e441ccba$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $5d00ee66e441ccba$export$47a23917fcedd235);
var $5d00ee66e441ccba$export$3cae6a891a2fb0c1;
(function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
})($5d00ee66e441ccba$export$3cae6a891a2fb0c1 || ($5d00ee66e441ccba$export$3cae6a891a2fb0c1 = {}));
var $5d00ee66e441ccba$export$9ffa2df2d13a51e4;
(function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
})($5d00ee66e441ccba$export$9ffa2df2d13a51e4 || ($5d00ee66e441ccba$export$9ffa2df2d13a51e4 = {}));
var $5d00ee66e441ccba$export$37aa46ee833f23f2;
(function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
})($5d00ee66e441ccba$export$37aa46ee833f23f2 || ($5d00ee66e441ccba$export$37aa46ee833f23f2 = {}));
var $5d00ee66e441ccba$export$b715b908ae0969fa;
(function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
})($5d00ee66e441ccba$export$b715b908ae0969fa || ($5d00ee66e441ccba$export$b715b908ae0969fa = {}));
var $5d00ee66e441ccba$export$47a23917fcedd235;
(function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
})($5d00ee66e441ccba$export$47a23917fcedd235 || ($5d00ee66e441ccba$export$47a23917fcedd235 = {}));

});


parcelRegister("ajx4y", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $07f045f9f08d9204$export$10caa25085bdca55);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
async function $07f045f9f08d9204$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("lKOEf", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $7814cf240c11be32$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $7814cf240c11be32$export$3ee49b4c70c0ec29);

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $8GtZ0 = parcelRequire("8GtZ0");
var $4eEU1 = parcelRequire("4eEU1");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $3ZIER = parcelRequire("3ZIER");
const $7814cf240c11be32$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $7814cf240c11be32$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject)) (0, $guiFP.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $2OdyW.default)($7814cf240c11be32$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $8GtZ0.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $8GtZ0.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $4eEU1.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $3ZIER.savePanelState)(actionProps))(data);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $3gGTI.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("3gGTI", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $06938d82719cce50$export$344601bd15a7b6d);
const $06938d82719cce50$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $06938d82719cce50$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $06938d82719cce50$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("8GtZ0", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $72b93b78f031cb2c$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $72b93b78f031cb2c$export$1cb8c028028700ec);

var $8u09c = parcelRequire("8u09c");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $72b93b78f031cb2c$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $8u09c.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTab: (0, $8u09c.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTour: (0, $8u09c.ProductTourKey).Welcome
        }
    }
};
const $72b93b78f031cb2c$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $8u09c.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $8u09c.ActiveState).On,
            visualState: (0, $8u09c.VisualState).FullPanel,
            sectionState: JSON.stringify($72b93b78f031cb2c$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).No
        }
    }
};
const $72b93b78f031cb2c$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("3ZIER", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $98e7316a9047ea56$export$8756ef0989d9dd58);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");
const $98e7316a9047ea56$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $98e7316a9047ea56$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($98e7316a9047ea56$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("zvnJx", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $63ec54d2a46c288c$export$e6838fe71dc9c3f5);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $8u09c = parcelRequire("8u09c");

var $3ZIER = parcelRequire("3ZIER");
const $63ec54d2a46c288c$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $3ZIER.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("82jJZ", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $e6623632044ca83f$export$3f8a23b1578c0a37);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $8u09c = parcelRequire("8u09c");

var $lKOEf = parcelRequire("lKOEf");

var $aXUph = parcelRequire("aXUph");
const $e6623632044ca83f$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $lKOEf.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).VisualState,
                    value: (0, $8u09c.VisualState).FullPanel
                });
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).ActiveState,
                    value: (0, $8u09c.ActiveState).On
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("aXUph", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $4fd2e9e2afb8272e$export$3d751d226e9d1512);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");
const $4fd2e9e2afb8272e$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $4fd2e9e2afb8272e$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($4fd2e9e2afb8272e$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("kYwcF", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $e0acf0603356b206$export$7c43f246bcca61d3);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");


var $3gGTI = parcelRequire("3gGTI");

var $6vrw7 = parcelRequire("6vrw7");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $e0acf0603356b206$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $e0acf0603356b206$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $e0acf0603356b206$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $e0acf0603356b206$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $6vrw7.toProjectId)(properties.user.projectId || '');
                    await (0, $3gGTI.withExponentialBackoffRetries)({
                        callback: ()=>(0, $5G2eQ.default)($e0acf0603356b206$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("1mctb", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $ac16bf64e18ce8db$export$b9e7846826f1ebfd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $4eEU1 = parcelRequire("4eEU1");
const $ac16bf64e18ce8db$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $4eEU1.VisibilityValues).Visible : (0, $4eEU1.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $4eEU1.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("ghO9h", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $73f30f16f4664d6e$export$3566fd94709fa84a);
const $73f30f16f4664d6e$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5palF")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("iFQsc")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("10YNr")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cVR9C")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5palF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kd6Ju").then(()=>parcelRequire('appSk'));

});

parcelRegister("iFQsc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5eFqM")
]).then(()=>parcelRequire('ddfk6'));

});

parcelRegister("10YNr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ahRif")
]).then(()=>parcelRequire('1HvEW'));

});

parcelRegister("cVR9C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("cxrYi")
]).then(()=>parcelRequire('f9sDQ'));

});


parcelRegister("2wMrb", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $967eaa8dc0617775$export$bfbf80c212b0dcb9);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $i889l = parcelRequire("i889l");

var $fO5rB = parcelRequire("fO5rB");

var $6QL9v = parcelRequire("6QL9v");
const $967eaa8dc0617775$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data && (0, $i889l.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
            subProduct: (0, $6QL9v.getSubProductFromProjectType)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("i889l", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $bedad64595855821$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $bedad64595855821$export$8d1083037a4a6250);
const $bedad64595855821$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $bedad64595855821$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});



parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $eI64M = parcelRequire("eI64M");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $d103d2cdc5840880$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $d103d2cdc5840880$export$9e38610dc1164d7d = (0, $dnJL9.componentWithFG)('projectsettingscontroller_error_boundary', $d103d2cdc5840880$export$6d6f90026f9508a7, $d103d2cdc5840880$export$2164d5fb3f070c32);
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew, $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("1DZLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e1e80a9d3c4e486$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");


var $bvmCN = parcelRequire("bvmCN");

var $2QKoh = parcelRequire("2QKoh");

var $8TZ1Z = parcelRequire("8TZ1Z");
class $5e1e80a9d3c4e486$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        const { baseUrl: baseUrl, environment: environment } = props.tenantContext;
        // If environment is null it will be treated as prod; we set it to an empty string just to satisfy type checking
        this.store = (0, $2QKoh.default)((0, $bvmCN.default), baseUrl, environment || '');
    }
    render() {
        const { tenantContext: tenantContext, projectContext: projectContext } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            id: (0, $87152ecb5ef8ce49$export$a7dd249cd65f11c6),
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8TZ1Z.default), {
            tenantContext: tenantContext,
            projectContext: projectContext
        })));
    }
}

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

const $87152ecb5ef8ce49$export$29cee3cd1768df6 = 'staging.halp.com';
const $87152ecb5ef8ce49$export$dcf9c4a7f304d495 = 'halp.com';
const $87152ecb5ef8ce49$export$efee12098e888868 = 'getChatAppStatusError';
const $87152ecb5ef8ce49$export$b49bada747fd39cd = 'installChatAppError';
const $87152ecb5ef8ce49$export$a7dd249cd65f11c6 = 'servicedesk.chat-settings';
const $87152ecb5ef8ce49$export$c329128ea6c2326f = 'chatAppNotEnabledError';
const $87152ecb5ef8ce49$export$5721fd5d6ba543ca = 'project-settings-apps.service-desk-chat-settings';

parcelRegister("bvmCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $613eb05a1a5e339c$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $6cCYd = parcelRequire("6cCYd");

var $jsz4U = parcelRequire("jsz4U");
var // @ts-expect-error - TS2769 - No overload matches this call.
$613eb05a1a5e339c$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $6cCYd.default), (0, $jsz4U.default));

});
parcelRegister("6cCYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc58bdd06aa4be8$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");


var $kUARA = parcelRequire("kUARA");

var $hbscC = parcelRequire("hbscC");

var $j7zAI = parcelRequire("j7zAI");
const $8dc58bdd06aa4be8$var$handleSuccess = (response)=>{
    const addonStatus = {
        installed: true,
        enabled: false
    };
    if (response.state === 'ENABLED') {
        addonStatus.enabled = true;
        return (0, $hbscC.loadChatSettingsPage)(addonStatus);
    }
    return (0, $hbscC.getChatAppStatusFailure)((0, $87152ecb5ef8ce49$export$c329128ea6c2326f));
};
const $8dc58bdd06aa4be8$var$handleFailure = (errorResponse, analyticsEvent)=>{
    if (errorResponse.statusCode !== 404) return (0, $hbscC.getChatAppStatusFailure)(errorResponse.message);
    return (0, $hbscC.installChatApp)(analyticsEvent);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8dc58bdd06aa4be8$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $hbscC.GET_CHAT_APP_STATUS)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $j7zAI.getBaseUrl)(state);
        const addonKey = (0, $j7zAI.getAddonKey)(state);
        return (0, $kUARA.default)(baseUrl, addonKey).map((getChatAppStatusResponse)=>$8dc58bdd06aa4be8$var$handleSuccess(getChatAppStatusResponse)).catch((error)=>(0, $3JafE.Observable).of($8dc58bdd06aa4be8$var$handleFailure(error, action.meta.analyticsEvent)));
    });

});
parcelRegister("kUARA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef1f7d7fe02e64b$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
const $fef1f7d7fe02e64b$var$getChatAppStatusUrl = (baseUrl, addonKey)=>`${baseUrl}/rest/atlassian-connect/1/addons/${addonKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fef1f7d7fe02e64b$export$2e2bcd8739ae039 = (baseUrl, addonKey)=>(0, $aiRd8.default)($fef1f7d7fe02e64b$var$getChatAppStatusUrl(baseUrl, addonKey), {
        method: 'GET'
    });

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});


parcelRegister("hbscC", function(module, exports) {

$parcel$export(module.exports, "GET_CHAT_APP_STATUS", () => $02682beeb02e0d34$export$2855fc8fbdb07646);
$parcel$export(module.exports, "getChatAppStatus", () => $02682beeb02e0d34$export$533b75a72b6aa66f);
$parcel$export(module.exports, "GET_CHAT_APP_STATUS_FAILURE", () => $02682beeb02e0d34$export$827e29fa2119992a);
$parcel$export(module.exports, "getChatAppStatusFailure", () => $02682beeb02e0d34$export$74ae70e58a8b2ba1);
$parcel$export(module.exports, "LOAD_CHAT_SETTINGS_PAGE", () => $02682beeb02e0d34$export$17bd120f373f69ac);
$parcel$export(module.exports, "loadChatSettingsPage", () => $02682beeb02e0d34$export$e0fe39dae5a06a23);
$parcel$export(module.exports, "INSTALL_CHAT_APP", () => $02682beeb02e0d34$export$3f96cb500eb88d67);
$parcel$export(module.exports, "installChatApp", () => $02682beeb02e0d34$export$4ef542ad08b0a822);
$parcel$export(module.exports, "INSTALL_CHAT_APP_FAILURE", () => $02682beeb02e0d34$export$e930fbbecde02cf2);
$parcel$export(module.exports, "installChatAppFailure", () => $02682beeb02e0d34$export$7f44b4ac5c12a31);
const $02682beeb02e0d34$export$2855fc8fbdb07646 = 'chat-settings.state.GET_CHAT_APP_STATUS';
const $02682beeb02e0d34$export$533b75a72b6aa66f = (analyticsEvent)=>({
        type: $02682beeb02e0d34$export$2855fc8fbdb07646,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $02682beeb02e0d34$export$827e29fa2119992a = 'chat-settings.state.GET_CHAT_APP_STATUS_FAILURE';
const $02682beeb02e0d34$export$74ae70e58a8b2ba1 = (errorMessage)=>({
        type: $02682beeb02e0d34$export$827e29fa2119992a,
        payload: {
            errorMessage: errorMessage
        }
    });
const $02682beeb02e0d34$export$17bd120f373f69ac = 'chat-settings.state.LOAD_CHAT_SETTINGS_PAGE';
const $02682beeb02e0d34$export$e0fe39dae5a06a23 = (addonStatus)=>({
        type: $02682beeb02e0d34$export$17bd120f373f69ac,
        payload: {
            addonStatus: addonStatus
        }
    });
const $02682beeb02e0d34$export$3f96cb500eb88d67 = 'chat-settings.state.INSTALL_CHAT_APP';
const $02682beeb02e0d34$export$4ef542ad08b0a822 = (analyticsEvent)=>({
        type: $02682beeb02e0d34$export$3f96cb500eb88d67,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $02682beeb02e0d34$export$e930fbbecde02cf2 = 'chat-settings.state.INSTALL_CHAT_APP_FAILURE';
const $02682beeb02e0d34$export$7f44b4ac5c12a31 = (errorMessage)=>({
        type: $02682beeb02e0d34$export$e930fbbecde02cf2,
        payload: {
            errorMessage: errorMessage
        }
    });

});

parcelRegister("j7zAI", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $9634652efa5d8377$export$f654b28f82155665);
$parcel$export(module.exports, "getAddonKey", () => $9634652efa5d8377$export$b6ff28888e5083c4);
$parcel$export(module.exports, "getIsLoading", () => $9634652efa5d8377$export$439d81b5ff19f64f);
$parcel$export(module.exports, "getIsInstalled", () => $9634652efa5d8377$export$23268a69efc131f1);
$parcel$export(module.exports, "getIsEnabled", () => $9634652efa5d8377$export$9b093d267eafd8d5);
$parcel$export(module.exports, "getErrorReason", () => $9634652efa5d8377$export$4ca74ba433f2c68e);
$parcel$export(module.exports, "getErrorMessage", () => $9634652efa5d8377$export$82f46aa4e6535a45);

const $9634652efa5d8377$export$f654b28f82155665 = (state)=>state.baseUrl;
const $9634652efa5d8377$export$b6ff28888e5083c4 = (state)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    state.environment === 'staging' || window.location.hostname.includes('jira-dev.com') ? (0, $87152ecb5ef8ce49$export$29cee3cd1768df6) : (0, $87152ecb5ef8ce49$export$dcf9c4a7f304d495);
const $9634652efa5d8377$export$439d81b5ff19f64f = (state)=>state.isLoading;
const $9634652efa5d8377$export$23268a69efc131f1 = (state)=>state.isInstalled;
const $9634652efa5d8377$export$9b093d267eafd8d5 = (state)=>state.isEnabled;
const $9634652efa5d8377$export$4ca74ba433f2c68e = (state)=>state.errorReason;
const $9634652efa5d8377$export$82f46aa4e6535a45 = (state)=>state.errorMessage;

});


parcelRegister("jsz4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f28306d89972ae$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8SBcT");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $9OtLL = parcelRequire("9OtLL");

var $hbscC = parcelRequire("hbscC");

var $j7zAI = parcelRequire("j7zAI");
const $b6f28306d89972ae$var$sendInstallChatAppSuccessEvent = (event)=>(0, $jUhyG.fireTrackAnalytics)(event, {
        action: 'installChatAppSuccess'
    });
const $b6f28306d89972ae$var$sendInstallChatAppFailureEvent = (event, error)=>(0, $jUhyG.fireTrackAnalytics)(event, {
        action: 'installChatAppFailure',
        attributes: {
            error: {
                statusCode: error.statusCode,
                message: error.message
            }
        }
    });
const $b6f28306d89972ae$var$handleSuccess = ()=>{
    const addonStatus = {
        installed: true,
        enabled: true
    };
    return (0, $hbscC.loadChatSettingsPage)(addonStatus);
};
const $b6f28306d89972ae$var$handleFailure = (errorResponse)=>(0, $hbscC.installChatAppFailure)(errorResponse.message);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6f28306d89972ae$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $hbscC.INSTALL_CHAT_APP)).mergeMap((action)=>{
        const state = store.getState();
        const baseUrl = (0, $j7zAI.getBaseUrl)(state);
        const addonKey = (0, $j7zAI.getAddonKey)(state);
        return (0, $9OtLL.default)(baseUrl, addonKey)// We delay here so the installer page doesn't flash when being displayed
        .delay(5000).map(()=>{
            $b6f28306d89972ae$var$sendInstallChatAppSuccessEvent(action.meta.analyticsEvent);
            return $b6f28306d89972ae$var$handleSuccess();
        }).catch((error)=>{
            $b6f28306d89972ae$var$sendInstallChatAppFailureEvent(action.meta.analyticsEvent, error);
            return (0, $3JafE.Observable).of($b6f28306d89972ae$var$handleFailure(error));
        });
    });

});
parcelRegister("9OtLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $499b760be3e1aa30$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $lRmyA = parcelRequire("lRmyA");
const $499b760be3e1aa30$var$installChatAppUrl = (baseUrl)=>`${baseUrl}/rest/atlassian-connect/1/systemaddons/install`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$499b760be3e1aa30$export$2e2bcd8739ae039 = (baseUrl, addonKey)=>(0, $3JafE.Observable).fromPromise((0, $lRmyA.performPostRequest)($499b760be3e1aa30$var$installChatAppUrl(baseUrl), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            addonKey: addonKey
        })
    }));

});



parcelRegister("2QKoh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdcdc06a17ed4c80$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");


var $3ibR9 = parcelRequire("3ibR9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fdcdc06a17ed4c80$export$2e2bcd8739ae039 = (rootEpic, baseUrl, environment)=>(0, $8FRHo.default)({
        appName: (0, $87152ecb5ef8ce49$export$a7dd249cd65f11c6),
        rootReducer: // @ts-expect-error - TS2322 - Type '(state: State, action: Action) => State' is not assignable to type 'Reducer<State>'.
        $3ibR9.default,
        initialState: (0, $3ibR9.createInitialState)(baseUrl, environment),
        rootEpic: rootEpic
    });

});
parcelRegister("3ibR9", function(module, exports) {

$parcel$export(module.exports, "createInitialState", () => $12faa7decea52fa8$export$de5e90bd767c5d82);
$parcel$export(module.exports, "default", () => $12faa7decea52fa8$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");


var $hbscC = parcelRequire("hbscC");
const $12faa7decea52fa8$export$de5e90bd767c5d82 = (baseUrl, environment)=>// @ts-expect-error - TS2322 - Type '{ baseUrl: string; environment: string; isLoading: true; isInstalled: false; isEnabled: false; errorReason: ""; errorMessage: string; }' is not assignable to type 'State'.
    (0, $6HC1D.freeze)({
        baseUrl: baseUrl,
        environment: environment,
        isLoading: true,
        isInstalled: false,
        isEnabled: false,
        errorReason: '',
        errorMessage: ''
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12faa7decea52fa8$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 0, $hbscC.GET_CHAT_APP_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false,
                errorReason: (0, $87152ecb5ef8ce49$export$efee12098e888868),
                errorMessage: action.payload.errorMessage
            };
        case 0, $hbscC.LOAD_CHAT_SETTINGS_PAGE:
            return {
                ...state,
                isLoading: false,
                isInstalled: action.payload.addonStatus.installed,
                isEnabled: action.payload.addonStatus.enabled,
                errorMessage: ''
            };
        case 0, $hbscC.INSTALL_CHAT_APP:
            return {
                ...state,
                isLoading: false,
                errorMessage: ''
            };
        case 0, $hbscC.INSTALL_CHAT_APP_FAILURE:
            return {
                ...state,
                isLoading: false,
                errorReason: (0, $87152ecb5ef8ce49$export$b49bada747fd39cd),
                errorMessage: action.payload.errorMessage
            };
        default:
            return state;
    }
};

});


parcelRegister("8TZ1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb6fdfef2a67593$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $lNNXV = parcelRequire("lNNXV");

var $hbscC = parcelRequire("hbscC");

var $j7zAI = parcelRequire("j7zAI");

var $30dBg = parcelRequire("30dBg");
const $ccb6fdfef2a67593$var$mapStateToProps = (state)=>({
        isLoading: (0, $j7zAI.getIsLoading)(state),
        isInstalled: (0, $j7zAI.getIsInstalled)(state),
        isEnabled: (0, $j7zAI.getIsEnabled)(state),
        errorReason: (0, $j7zAI.getErrorReason)(state),
        errorMessage: (0, $j7zAI.getErrorMessage)(state),
        addonKey: (0, $j7zAI.getAddonKey)(state)
    });
const $ccb6fdfef2a67593$var$mapDispatchToProps = {
    onGetChatAppStatus: (0, $hbscC.getChatAppStatus)
};
var $ccb6fdfef2a67593$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($ccb6fdfef2a67593$var$mapStateToProps, $ccb6fdfef2a67593$var$mapDispatchToProps)((0, $giAhk.injectIntlV2)((0, $30dBg.default)));

});
parcelRegister("30dBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18305910b4374dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $8npnf = parcelRequire("8npnf");

var $hFmdR = parcelRequire("hFmdR");

var $jPfP5 = parcelRequire("jPfP5");

var $eGI9v = parcelRequire("eGI9v");

var $aTgXo = parcelRequire("aTgXo");

var $foc4i = parcelRequire("foc4i");

var $eI5EY = parcelRequire("eI5EY");

var $gGtKh = parcelRequire("gGtKh");


var $cqJw8 = parcelRequire("cqJw8");

var $2d7Sj = parcelRequire("2d7Sj");

var $ifUq1 = parcelRequire("ifUq1");

var $45Yam = parcelRequire("45Yam");

var $5GZPg = parcelRequire("5GZPg");

var $jRXa5 = parcelRequire("jRXa5");
const $a18305910b4374dc$var$Loading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRXa5.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null));

const $a18305910b4374dc$export$bc1123521ebc8f17 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jQ1Rs")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/chat-settings/view/ChatSettingsPage.tsx"
});
const $a18305910b4374dc$export$13df5e7434a245df = ({ onGetChatAppStatus: onGetChatAppStatus, isInstalled: isInstalled, isEnabled: isEnabled, isLoading: isLoading, projectContext: projectContext, tenantContext: tenantContext, errorMessage: errorMessage, errorReason: errorReason, addonKey: addonKey, intl: intl })=>{
    const [queryRef, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $45Yam.NativeConfigEnabled));
    const refresh = (0, $eUqFw.useCallback)(()=>{
        if (projectContext?.projectId && tenantContext.activationId && tenantContext.activationId) loadQuery({
            jiraProjectAri: (0, $8npnf.JiraProjectAri).create({
                siteId: tenantContext.cloudId,
                projectId: projectContext.projectId.toString()
            }).toString()
        });
    }, [
        loadQuery,
        tenantContext,
        projectContext
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onGetChatAppStatus();
        refresh();
    }, [
        onGetChatAppStatus,
        refresh
    ]);
    const { formatMessage: formatMessage } = intl;
    if (isLoading || !projectContext || !tenantContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a18305910b4374dc$var$Loading, null);
    const { baseUrl: baseUrl } = tenantContext;
    const { projectKey: projectKey, projectType: projectType, projectName: projectName, simplified: simplified } = projectContext;
    // render the default breadcrumb provided by AppContainer, for classic projects
    if (!simplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "chat"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: baseUrl,
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "chat-settings-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a18305910b4374dc$var$Loading, null)
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a18305910b4374dc$export$bc1123521ebc8f17, {
        isInstalled: isInstalled,
        isEnabled: isEnabled,
        projectContext: projectContext,
        tenantContext: tenantContext,
        errorMessage: errorMessage,
        errorReason: errorReason,
        intl: intl,
        queryRef: queryRef,
        addonKey: addonKey
    }))));
    const channelsHref = `${(0, $cqJw8.getNextgenSettingsUrl)(projectType, projectKey)}/channels`;
    const pageContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "chat-settings-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a18305910b4374dc$var$Loading, null)
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a18305910b4374dc$export$bc1123521ebc8f17, {
        isInstalled: isInstalled,
        isEnabled: isEnabled,
        projectContext: projectContext,
        tenantContext: tenantContext,
        errorMessage: errorMessage,
        errorReason: errorReason,
        intl: intl,
        queryRef: queryRef,
        addonKey: addonKey
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "chat"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: baseUrl,
        projectKey: projectKey
    }, (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') ? pageContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $5GZPg.default).channelBreadcrumb),
            href: channelsHref,
            type: 'servicedeskChannelsBreadcrumb'
        }
    }, pageContent)));
};
var $a18305910b4374dc$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSubject)('chatProjectSettings', {
    get referrer () {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const params = new URLSearchParams(document.location.search);
        return params?.get('referrer');
    }
})((0, $hFmdR.AnalyticsSource)('chatProjectSettings', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))((0, $eGI9v.default)('chatProjectSettingsInstall', {
    onGetChatAppStatus: 'onGetChatAppStatus'
})($a18305910b4374dc$export$13df5e7434a245df)));

});
parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("45Yam", function(module, exports) {

$parcel$export(module.exports, "NativeConfigEnabled", () => $805af6d3880dcba1$export$81db5379d297685b);

var $950XD = parcelRequire("950XD");
const $805af6d3880dcba1$export$81db5379d297685b = (0, $950XD.default);

});
parcelRegister("950XD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f02677fcf86e50cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76776a0dd9f8fbe0cec0074a0ba5a4e5>>
 * @relayHash 38dac4d280f1061b565a4f344f61745d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afd4a8148418253722aabe40c825a47206a3ab3801ebcba1542a16c9fbc39109
const $f02677fcf86e50cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        }
    ], v1 = [
        {
            "concreteType": "JsmChatQuery",
            "kind": "LinkedField",
            "name": "jsmChat",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "jiraProjectAri",
                            "variableName": "jiraProjectAri"
                        }
                    ],
                    "concreteType": "JsmChatInitializeNativeConfigResponse",
                    "kind": "LinkedField",
                    "name": "initializeNativeConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "nativeConfigEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "connectedApp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeConfigEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeConfigEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "afd4a8148418253722aabe40c825a47206a3ab3801ebcba1542a16c9fbc39109",
            "metadata": {},
            "name": "NativeConfigEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f02677fcf86e50cf$var$node.hash = "eca7adbc2cba5d0f749362ca84cdd8eb";
var $f02677fcf86e50cf$export$2e2bcd8739ae039 = $f02677fcf86e50cf$var$node;

});


parcelRegister("5GZPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8da6f605ec815d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ba8da6f605ec815d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    breadcrumbs: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.breadcrumbs",
        "defaultMessage": "Chat"
    },
    title: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.title",
        "defaultMessage": "Chat"
    },
    installingChat: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.installing-chat",
        "defaultMessage": "We\u2019re setting up chat for you. This may take a few minutes."
    },
    getChatAppStatusErrorBeforeLink: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-before-link",
        "defaultMessage": "We couldn\u2019t load chat."
    },
    getChatAppStatusErrorLinkText: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-link-text",
        "defaultMessage": "Refresh the page"
    },
    getChatAppStatusErrorAfterLink: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.get-chat-app-status-error-after-link",
        "defaultMessage": " and try again."
    },
    installChatAppErrorBeforeLink: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-before-link",
        "defaultMessage": "We couldn\u2019t install chat."
    },
    installChatAppErrorLinkText: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-link-text",
        "defaultMessage": "Refresh the page"
    },
    installChatAppErrorAfterLink: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.install-chat-app-error-after-link",
        "defaultMessage": "and try again."
    },
    channelBreadcrumb: {
        "id": "spa-apps.project-settings.service-desk-chat-settings.chat-settings.channel-breadcrumb",
        "defaultMessage": "Channels"
    }
});

});

parcelRegister("jRXa5", function(module, exports) {

$parcel$export(module.exports, "SpinnerContainer", () => $ca1bd86c74b1c788$export$a5e06607a5ac6158);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ca1bd86c74b1c788$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pk1ejb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jQ1Rs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("jnTsu")
]).then(()=>parcelRequire('8x1eV'));

});




parcelRegister("eZLHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e37754629d4b4d7$export$2e2bcd8739ae039);

var $7ZZxN = parcelRequire("7ZZxN");

var $ixwgj = parcelRequire("ixwgj");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $0e37754629d4b4d7$export$9c542858adf7dcd0 = {
    projectKey: (0, $6vrw7.toProjectKey)(''),
    projectId: -1,
    projectUuid: undefined,
    projectName: '',
    avatarUrl: '',
    simplified: false,
    projectType: (0, $7ZZxN.SERVICE_DESK_PROJECT),
    isProjectAdmin: false
};
// @ts-expect-error - TS2322 - Type '() => { data: ProjectContext; loading: boolean; error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; }' is not assignable to type 'ProjectContextService'.
const $0e37754629d4b4d7$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    return {
        data: data || $0e37754629d4b4d7$export$9c542858adf7dcd0,
        loading: loading,
        error: error
    };
};
var $0e37754629d4b4d7$export$2e2bcd8739ae039 = $0e37754629d4b4d7$var$useProjectContext;

});



//# sourceMappingURL=async-project-settings-service-desk-chat-settings.e7fc3bea.js.map
